'use client';

import { usePathname, useSearchParams } from 'next/navigation';

import { useAppSelector } from '@/store';

import { generateApproperiateURL, getWebaliasAlongWithRestPath } from '../utils/urlHelpers';

type WebaliasObject = { webalias: string; urlPath: string; generateURL: typeof generateApproperiateURL };

export default function useWebAlias(): WebaliasObject {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const webAliasFromStore = useAppSelector(store => store.slices.webaliasSlice.webalias);

  const currentPath = searchParams.toString().length ? `${pathname}?${searchParams.toString()}` : pathname;

  const { urlPath, webalias: calcWebalias } = getWebaliasAlongWithRestPath(currentPath);
  const webalias = (calcWebalias || webAliasFromStore).replaceAll(/\?.*/g, '');

  if (globalThis.window) globalThis.window.PAWTREE_CURRENT_WEBALIAS = webalias;

  return {
    webalias: webalias,
    urlPath,
    generateURL: generateApproperiateURL,
  };
}
